<template>
  <div>
    <div
      class="header"
      :style="{ backgroundColor: '#' + retailerColor || 'var(--primary)' }"
    >
      <div :class="hasContainer ? 'isContainer' : ''">
        <Asset
          :name="retailerLogo || 'logo-white.svg'"
          alt="Logo"
          title="Logo"
          :version="null"
        />
      </div>
    </div>
    <slot/>
  </div>
</template>

<script>
import Asset from '@/components/common/Asset.vue';

export default {
  name: 'generic-header',
  components: { Asset },
  props: {
    retailerColor: {
      type: String,
    },
    retailerLogo: {
      type: String,
    },
    hasContainer: {
      type: Boolean,
    },
  },

};
</script>

<style lang="scss" scoped>
.header {
  padding: 17px 0;

  background-color: var(--primary);
  box-sizing: border-box;
  height: 50px;

  @media (max-width: $md) {
    display: flex;
    justify-content: center;
    padding: 15px 0;
  }
}
img {
  @media (max-width: $md) {
    height: 20px;
  }
  height: 16px;
  width: auto;
}
.isContainer {
  @extend .container;
}

</style>
